__turbopack_context__.v({
  "className": "pacifico_2b555e8f-module__59ygLW__className",
  "variable": "pacifico_2b555e8f-module__59ygLW__variable",
});
